import { useDispatch } from '@redux';
import {
  completeReturn,
  getByIdOrdersReturn,
  paymentRefund,
} from '@redux/ordersReturn/actions';
import { Button, Card, Form, Space } from 'antd';
import { useRestContext } from 'components/form/RestInputContext';
import { RETURN_REFUND_STATUS, RETURN_STATUS } from 'constants/ordersReturn';
import _ from 'lodash';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from 'utils/formattedString';
import ConfirmRefundModal from './ModalConfirm/ConfirmRefundModal';

export default function RefundMethod() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refModal = useRef<{ open: () => void }>();
  const { record } = useRestContext();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (
      record?.refundPaymentMethod?.name === 'cod' ||
      record?.refundPaymentMethod?.name === 'bank' ||
      record?.order?.paymentType === 'cod' ||
      record?.order?.paymentType === 'bank'
    ) {
      refModal.current.open();
    } else if (record?.exchangeId) {
      setLoading(true);
      dispatch(
        completeReturn({
          data: { id: record?.id },
        }),
      )
        .then(() => {
          dispatch(
            getByIdOrdersReturn({
              data: { id: record?.id },
              options: { isRequestApi: true, isRefresh: true },
            }),
          ).finally(() => setLoading(false));
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      dispatch(
        paymentRefund({
          data: { id: record?.id, data: { reason: record?.reason } },
        }),
      )
        .then(() => {
          dispatch(
            getByIdOrdersReturn({
              data: { id: record?.id },
              options: { isRequestApi: true, isRefresh: true },
            }),
          ).finally(() => setLoading(false));
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Card title={t('ordersReturn.refundInformation')}>
        <Space
          direction="vertical"
          size={5}
          className="text-text-dark-gray block"
        >
          <div className="font-semibold">
            {record?.refundPaymentMethod?.name || record?.order?.paymentType}
          </div>
          <div className="opacity-50">
            {_.compact([
              record?.bankName,
              record?.bankAccountName,
              record?.bankAccountNumber,
            ]).join(' | ')}
          </div>
          <div className="opacity-50">{record?.refundDescription}</div>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.subTotalRefund !== curValues.subTotalRefund
            }
          >
            {({ getFieldValue }) => {
              const subTotalRefund = getFieldValue('subTotalRefund');
              return !record?.exchangeId
                ? formatMoney(record?.totalRefund)
                : formatMoney(subTotalRefund);
            }}
          </Form.Item>
        </Space>
        {record?.status === RETURN_STATUS['WAITING_FOR_REFUND'].value &&
          record?.refundPaymentMethod?.name !== 'fundiin' &&
          !record?.exchangeId &&
          !record?.isMarketPlace &&
          (record?.refundStatus === RETURN_REFUND_STATUS['REFUND_FAILED'] ||
            record?.refundStatus === null) && (
            <Button
              loading={loading}
              onClick={handleConfirm}
              type="primary"
              className="btn-h-32 mt-2 w-full"
            >
              {t('button.confirmRefund')}
            </Button>
          )}
      </Card>
      <ConfirmRefundModal
        ref={refModal}
        id={record?.id}
        reason={record?.reason}
      />
    </>
  );
}
